import { connect } from 'react-redux';

import { newErrorNotification, newWarningNotification } from '../../components/common/redux/actions/notificationActions';

import component from './component';

export default connect(null, {
  newError: newErrorNotification,
  newWarning: newWarningNotification,
})(component);
